///<reference path="custom-validation.model.ts"/>

module Meevo.Components.Controls.SmartMover {

    export abstract class CustomValidationBase implements ICustomValidation {
        abstract readonly placement: ErrorMessagePlacements;
        abstract readonly valid: boolean;
        abstract readonly message?: string;
    }
}
